'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'email',
    shape: _react2.default.createElement('path', {
        d: 'M485.211,80.792V424.56H0V80.792l242.606,212.282L485.211,80.792z M462.174,60.651H23.027l219.579,192.142L462.174,60.651z'
    }),
    viewbox: '0 0 485.211 485.211',
    label: 'Email'
};
//# sourceMappingURL=email.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/email.js
 ** module id = 686
 ** module chunks = 1
 **/